import { action, makeAutoObservable, reaction, runInAction } from "mobx";
import { Money } from "../Money";
import { Availability } from "../Availability";
export class Delivery {
    constructor(params) {
        this.lastDeliveryPolicy = null;
        this.defaultMinOrderValue = params.defaultMinOrderValue;
        makeAutoObservable(this);
        // FIXME Debounce  fix memory leak
        reaction(() => { var _a, _b; return (_b = (_a = params.fulfillmentInstructions.streetAddress) === null || _a === void 0 ? void 0 : _a.checkoutData) !== null && _b !== void 0 ? _b : null; }, (geocodingAddress) => {
            runInAction(() => {
                this.lastDeliveryPolicy = null;
            });
            params.geocodingService
                .getDeliveryPolicy(params.restaurantId, geocodingAddress)
                .then(action((deliveryPolicy) => {
                this.lastDeliveryPolicy = deliveryPolicy;
            }))
                .catch((err) => console.log("Error while refreshing delivery policy: ", err));
        }, { fireImmediately: true });
    }
    get cost() {
        if (this.lastDeliveryPolicy === null) {
            return Money.zero();
        }
        return this.lastDeliveryPolicy.deliveryCost;
    }
    get minOrderValue() {
        var _a, _b;
        return (_b = (_a = this.lastDeliveryPolicy) === null || _a === void 0 ? void 0 : _a.minOrderValue) !== null && _b !== void 0 ? _b : this.defaultMinOrderValue;
    }
    price(orderValidationPrice) {
        if (this.lastDeliveryPolicy === null) {
            return Money.zero();
        }
        const deliveryValidationResult = this.lastDeliveryPolicy.validate(orderValidationPrice);
        switch (deliveryValidationResult) {
            case "FreeDeliveryPossible":
            case "DeliveryImpossible":
                return Money.zero();
            case "PaidDeliveryPossible":
                return this.cost;
        }
    }
    availability(orderValidationPrice) {
        if (this.lastDeliveryPolicy === null) {
            return Availability.unavailable("LoadingDeliveryPolicy");
        }
        const deliveryValidationResult = this.lastDeliveryPolicy.validate(orderValidationPrice);
        switch (deliveryValidationResult) {
            case "DeliveryImpossible":
                return Availability.unavailable(deliveryValidationResult);
            case "FreeDeliveryPossible":
            case "PaidDeliveryPossible":
                return Availability.available();
        }
    }
}
